module.exports = __webpack_public_path__ + "files/SPIADI2024 - Journée Nationale - Bulletin d'inscription.56c88af9cca9191c5a76f22b806c671f.pdf";